import { DefaultFetchService } from "../../services/fetchService";

const validateWidget = (widget: FixmeType) => !widget.durationObject.raw.isCustom;
const url = (id: string) => `/api/userdata/dashboards/${id}/subscriptions`;

export default {
    isSubscriptionOn: (dashboard: FixmeType) => dashboard.isSubscribedToNotifications,
    isNotificationAllowed: (dashboard: FixmeType) => {
        if (!dashboard.widgets.length) {
            return false;
        } else {
            return dashboard.widgets.some(validateWidget);
        }
    },
    subscribeToNotification: (id: string) => {
        return DefaultFetchService.getInstance().post(url(id), {});
    },
    unsubscribeToNotification: (id: string) => {
        return DefaultFetchService.getInstance().delete(url(id), {});
    },
};
